"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createUserAuthTokenInitialiser = exports.getTokenRoute = void 0;

var tslib_1 = require("tslib");

var dashboard_constants_1 = require("@hopin-team/dashboard-constants");

var package_details_1 = require("@hopin-team/package-details");

exports.getTokenRoute = 'users/sso';

var createUserAuthTokenInitialiser = function createUserAuthTokenInitialiser(_a) {
  var clientPackageDetails = _a.clientPackageDetails;
  return function () {
    return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
      var _a, name, version, response, _b, token, error;

      return (0, tslib_1.__generator)(this, function (_c) {
        switch (_c.label) {
          case 0:
            _a = (0, package_details_1.packageDetails)(clientPackageDetails || '@hopin-team/unknown/*'), name = _a.name, version = _a.version;
            return [4
            /*yield*/
            , fetch("".concat((0, dashboard_constants_1.getBaseUrl)(), "/").concat(exports.getTokenRoute), {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-HOPIN-CLIENT-NAME': name,
                'X-HOPIN-CLIENT-VERSION': version
              },
              credentials: 'include'
            })];

          case 1:
            response = _c.sent();
            return [4
            /*yield*/
            , response.json()];

          case 2:
            _b = _c.sent(), token = _b.token, error = _b.error;

            if (error) {
              throw new Error(error);
            }

            if (!token) {
              throw new Error('No token received');
            }

            return [2
            /*return*/
            , token];
        }
      });
    });
  };
};

exports.createUserAuthTokenInitialiser = createUserAuthTokenInitialiser;